<template>
    <v-form v-model="isValid">
        <v-card>
            <v-card-title>
                Zusammenfassung
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-card flat>
                            <v-card-title>
                                Deine persönlichen Daten
                            </v-card-title>
                            <v-card-text>
                                <p>
                                    <strong>Vorname: </strong>{{formData.personalData.mandator.prename}}
                                    <br/>
                                    <strong>Nachname: </strong>{{formData.personalData.mandator.surname}}
                                    <br/>
                                    <strong>Straße: </strong>{{formData.personalData.mandator.street}} {{formData.personalData.mandator.house_number}}
                                    <br/>
                                    <strong>PLZ: </strong>{{formData.personalData.mandator.zip}}
                                    <br/>
                                    <strong>Stadt: </strong>{{formData.personalData.mandator.city}}
                                    <br/>
                                    <strong>Email: </strong>{{formData.personalData.mandator.mail}}
                                    <br/>
                                    <strong>Telefonnummer: </strong>{{formData.personalData.mandator.phone}}
                                </p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card flat>
                            <v-card-title>Dein Flug</v-card-title>
                            <v-card-text>
                                <p>
                                    <strong>Startflughafen: </strong>{{formData.flightData.start}}
                                    <br/>
                                    <strong>Zielflughafen: </strong>{{formData.flightData.end}}
                                    <br/>
                                    <template v-if="hasStopover">
                                        <strong>Zwischenstopp: </strong>{{formData.flightData.stopover}}
                                        <br/>
                                        <strong>Airlines: </strong>{{mainAirlineTitle}} und {{subAirlineTitle}}
                                        <br/>
                                        <strong>Flugnummern: </strong>{{formData.flightData.flightnumber_main}} und {{formData.flightData.flightnumber_sub}}
                                        <br/>
                                    </template>
                                    <template v-else>
                                        <strong>Airline: </strong>{{mainAirlineTitle}}
                                        <br/>
                                        <strong>Flugnummer: </strong>{{formData.flightData.flightnumber_main}}
                                        <br/>
                                    </template>
                                    <strong>Geplante {{flightDateLabel}}: </strong>{{formattedPlannedRelevantDateText}}
                                    <br/>
                                    <strong>Tatsächliche {{flightDateLabel}}: </strong>{{actualRelevantDateText}}
                                    <br/>
                                    <strong>Falltyp: </strong>{{caseTypeLabel}}
                                </p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6" v-if="formData.personalData.fellowPassengers.length > 0">
                        <v-card flat>
                            <v-card-title>Mitreisende Personen</v-card-title>
                            <v-card-text>
                                <div v-for="(fellowPassenger, index) in formData.personalData.fellowPassengers" :key="index">
                                    <v-card outlined>
                                        <v-card-subtitle>Mitreisende Person Nr. {{index + 1}}</v-card-subtitle>
                                        <v-card-text>
                                            <p>
                                                <strong>Name: </strong>{{fellowPassenger.prename}} {{fellowPassenger.surname}}
                                                <br/>
                                                <strong>Straße: </strong>{{fellowPassenger.street}} {{fellowPassenger.house_number}}
                                                <br/>
                                                <strong>PLZ/Stadt: </strong>{{fellowPassenger.zip}} {{fellowPassenger.city}}
                                            </p>
                                        </v-card-text>
                                    </v-card>
                                    <br v-if="(index + 1) !== formData.personalData.fellowPassengers.length"/>
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-card flat>
                            <v-card-title>
                                Weitere Daten
                            </v-card-title>
                            <v-card-text>
                                <p>
                                    <template v-if="formData.hasRSV === '1'">
                                        <strong>Rechtsschutzversicherung: </strong>{{rsvTitle}} ({{rsvDeductibleText}})
                                        <br/>
                                    </template>
                                    <strong>IBAN: </strong>{{formData.personalData.mandator.iban}}
                                    <br/>
                                    <strong>BIC: </strong>{{formData.personalData.mandator.bic}}
                                    <template v-if="replacementTicketExpense !== null">
                                        <br/>
                                        <strong>Kosten Ersatzticket: </strong>{{replacementTicketExpense}}€
                                    </template>
                                </p>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-checkbox label="Hier klicken um das Einveständnis für xy und z zu erteilen."/>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-form>
</template>

<script>
import moment from "moment";
import CaseTypes from "@/constants/CaseTypes";

export default {
    name: 'SummaryPage',
    props: {
        formData: {
            type: Object,
            default: function()
            {
                return {
                    personalData: {
                        mandator: {
                            prename: null,
                            surname: null,
                            street: null,
                            city: null,
                            house_number: null,
                            zip: null,
                            iban: null,
                            bic: null,
                            mail: null,
                            phone: null
                        },
                        fellowPassengers: [],
                        expenses: [],
                        rsv_id: null
                    },
                    flightData: {
                        start: null,
                        end: null,
                        stopover: null,
                        flightnumber_main: null,
                        flightnumber_sub: null,
                        main_airline_id: null,
                        sub_airline_id: null,
                        planned_relevant_date: null,
                        actual_relevant_date: null
                    },
                    additionalData: {
                        rsv_deductible_amount: null
                    },
                    hasRSV: null
                };
            }
        },
        airlines: {
            type: Array,
            default: function()
            {
                return [];
            }
        },
        rsvs: {
            type: Array,
            default: function()
            {
                return [];
            }
        }
    },
    emits: ['validity-changed'],
    computed: {
        hasStopover()
        {
            return this.formData.flightData.stopover !== null;
        },
        replacementTicketExpense()
        {
            if(this.formData.personalData.expenses.length > 0)
            {
                if(this.formData.personalData.expenses[0].value)
                    return this.formData.personalData.expenses[0].value.toString().replace('.', ',');
            }

            return null;
        },
        rsvTitle()
        {
            if(this.formData.personalData.rsv_id)
            {
                let rsv = this.rsvs.find((rsv) => rsv.id === this.formData.personalData.rsv_id);

                return rsv.name;
            }

            return null;
        },
        mainAirlineTitle()
        {
            let airline = this.airlines.find((airline) => airline.id === this.formData.flightData.main_airline_id);

            if(airline !== undefined)
                return airline.name;

            return null;
        },
        subAirlineTitle()
        {
            let airline = this.airlines.find((airline) => airline.id === this.formData.flightData.sub_airline_id);

            if(airline !== undefined)
                return airline.name;

            return null;
        },
        rsvDeductibleText()
        {
            if(this.formData.hasRSV === '1')
            {
                if(this.formData.additionalData.rsv_deductible_amount !== null)
                    return '' + this.formData.additionalData.rsv_deductible_amount.toString().replace('.', ',') + '€ Selbstbeteiligung';

                return 'mit Selbstbeteiligung in unbekannter Höhe'
            }

            return null;
        },
        flightDateLabel()
        {
            if(this.formData.flightData.type === CaseTypes.CASE_TYPE_FORWARDED.value)
                return 'Abflugszeit';

            return 'Ankunftszeit';
        },
        caseTypeLabel()
        {
            switch(this.formData.flightData.type)
            {
                case CaseTypes.CASE_TYPE_FORWARDED.value:
                    return 'Verfrühung';
                case CaseTypes.CASE_TYPE_CANCELED.value:
                    return 'Annulierung';
                case CaseTypes.CASE_TYPE_NO_BOARDING.value:
                    return 'Untersagtes Boarding';
                default:
                    return 'Verspätung';
            }
        },
        formattedPlannedRelevantDateText()
        {
            if(this.formData.flightData.planned_relevant_date !== null)
                return moment(this.formData.flightData.planned_relevant_date).format('DD.MM.YYYY HH:mm');

            return null;
        },
        actualRelevantDateText()
        {
            if(this.formData.flightData.actual_relevant_date !== null)
                return moment(this.formData.flightData.actual_relevant_date).format('DD.MM.YYYY HH:mm');

            return 'Das Ziel wurde nicht erreicht';
        }
    },
    data: () => ({
        isValid: false,
    }),
    watch: {
        'isValid': function (newValue)
        {
            this.$emit('validity-changed', newValue);
        }
    }
}
</script>

<style scoped>

</style>
